// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__LGmxy","Main":"Layout_Main__lmudL","ModalTabsButton":"Layout_ModalTabsButton__cIV2s","active":"Layout_active__pabYE"};